import React from 'react';
import { Button, Form } from 'react-bootstrap';

import { ReceiptItemDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { VatEnum } from '../../../common/spdCore/validation/enums';
import { SalesInvoicePositionNameCreatableSelector } from '../../components/SalesInvoice/SalesInvoicePositionNameCreatableSelector';
import CurrencyControl from '../../../app/components/CurrencyControl';

interface ReceiptItemsListProps {
  items: ReceiptItemDto[];
  onItemChange: (
    index: number,
    field: keyof ReceiptItemDto,
    value: string | number,
  ) => void;
  onAddItem: () => void;
  onRemoveItem: (index: number) => void;
}

export const ReceiptItemsList: React.FC<ReceiptItemsListProps> = ({
  items,
  onItemChange,
  onAddItem,
  onRemoveItem,
}) => {
  return (
    <div>
      <label className="form-label">Pozycje paragonu</label>
      {items.map((item, index) => (
        <div
          key={index}
          className="border rounded p-3 mb-3 bg-light position-relative"
        >
          <div className="row">
            <div className="col-md-7">
              <Form.Group className="mb-2">
                <Form.Label className="small">Nazwa pozycji</Form.Label>
                <SalesInvoicePositionNameCreatableSelector
                  value={item.name}
                  onChange={value => onItemChange(index, 'name', value)}
                />
              </Form.Group>
            </div>
            <div className="col-md-1">
              <Form.Group className="mb-2">
                <Form.Label className="small">Ilość</Form.Label>
                <Form.Control
                  type="number"
                  value={item.quantity}
                  onChange={e =>
                    onItemChange(index, 'quantity', e.target.value)
                  }
                  min="1"
                />
              </Form.Group>
            </div>
            <div className="col-md-2">
              <Form.Group className="mb-2">
                <Form.Label className="small">Cena brutto</Form.Label>
                <CurrencyControl
                  value={item.price || ''}
                  decimalScale={2}
                  onChange={e =>
                    onItemChange(index, 'price', e ? e.toString() : '')
                  }
                />
              </Form.Group>
            </div>
            <div className="col-md-2">
              <Form.Group className="mb-2">
                <Form.Label className="small">Stawka VAT</Form.Label>
                <Form.Select
                  value={item.vat}
                  onChange={e => onItemChange(index, 'vat', e.target.value)}
                >
                  {Object.values(VatEnum).map(vat => (
                    <option key={vat} value={vat}>
                      {vat}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>
          </div>

          {items.length > 1 && (
            <button
              type="button"
              className="btn-close position-absolute top-0 end-0 m-2"
              onClick={() => onRemoveItem(index)}
              aria-label="Remove item"
            />
          )}
        </div>
      ))}
      <Button variant="secondary" onClick={onAddItem} className="w-100 mb-3">
        + Dodaj pozycję
      </Button>
    </div>
  );
};
